import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
import Paginate from 'vuejs-paginate'
import download from 'downloadjs';
import jsPDF from 'jspdf';
import JsBarcode from 'jsbarcode';
import Canvg from 'canvg';

export default {
	name: 'outbound-bins',
	components: {
		BasicSelect,
		VueElementLoading,
		DatePicker,
		Paginate,
		download,
		Canvg
	},
	props: [],
	data() {
		return {
			binno:'',
			hubid:'',
			FromDate: '',
      ToDate: '',
			isLoadingSearch:false,
			locationDetails:[],
			hublist:[],
			zoneList: [],
			zoneItem: {
				value: "",
				text: ""
			},
			zoneData: [],
			zoneRowWiseData: [],
			zoneLoading: '',
			zone: '',
			validDateRange:'',
			validDateRangeFrom:'',
			showTable: false,
			pageCount: 0,
      pageNo: 0,
			totalRows: 0,
      limit: 10,
			checkAll:false,
			binDetails:[],
			BinArr:[],
			csvFields: [],
      csvData:[],
      prnData:'',
      createdby:'',
			barc:[],
			ispdf:true
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.hubid = userdetail[0].HubId[0];
		this.createdby = userdetail[0].email;
		//if(['saurabh.jaiswal@xpressbees.com','kailas.patil@xpressbees.com'].indexOf(this.createdby) > -1) this.ispdf = true;

		this.getZoneList();
		this.getOutboundBin();
	},
	methods: {
		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YYYY') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },

		export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

		getZoneList() {
			this.zoneLoading = 'Loading Zone...'
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'hubzone/list',
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.zoneLoading = ''
					if (result.data.ResultCode == 100) {
						var ZoneDetails = result.data.ResponseData
						for (var i = 0; i < ZoneDetails.length; i++) {
							this.zoneList.push({
								"value": ZoneDetails[i].hubzoneid,
								"text": ZoneDetails[i].hubzonename,
							})
						}
					} else {
						this.$alert(result.data.ReturnMessage, "", "error");
					}
				}, error => {
					console.error(error)
				})
		},

		selectedZone(zoneItem) {
			this.zoneItem = zoneItem
			this.zone = zoneItem.text
		},

		getBinDetails: function() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {
          this.getOutboundBin();
        }
			}).catch(() => {
				console.log('errors exist');
			});
		},

		getOutboundBin(){
			this.onboundDetails=[];  this.BinArr = this.barc = [];

			if(this.zone){
				let z = this.zone.split('-');
				this.zone = z[0].trim() + (z[1] ? ' ' + z[1].trim() : '');
			}

			this.isLoadingSearch = true;
			this.input = ({
			  currentHubId: this.hubid,
			  zone: this.zone ? this.zone : null,
			  binNumber: this.binno ? this.binno : null,
				fromdate: this.FromDate ? moment(this.FromDate).format('YYYY-MM-DD') : null,
			  todate: this.ToDate ? moment(this.ToDate).format('YYYY-MM-DD') : null
			});

			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'getOutboundBin',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {

						this.binDetails = result.data.ResponseData[0];

						document.getElementById("Outbound").innerHTML = "Outbound( "+result.data.TotalCount+" )";

						// this.totalRows=result.data.TotalCount
            // if (this.totalRows < 10) {
            //   this.pageCount = 1
            // } else {
            //   this.pageCount = Math.ceil(this.totalRows / 10);
            // }
						this.$alertify.success(result.data.ReturnMessage);
					} else {
						document.getElementById("Outbound").innerHTML = "Outbound( 0 )";
						this.totalRows=0; this.binDetails = [];
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoadingSearch = false;
				}, error => {
					this.isLoadingSearch = true; console.error(error);
				})
		},

		getBinCSV(){
			this.csvData=[]
      this.binDetails.map(item=>{
        this.csvData.push({
          BinID: item.binno,
					PTLID:item.ptlid,
          ZoneID:item.Zone,
          GroupName: item.groupname,
          BinCreatedDateTime: item.bindate
        })
      })

			this.csvFields = {
				'BinID': 'BinID',
				'PTLID': 'PTLID',
				'ZoneID': 'ZoneID',
				'GroupName': 'Groupname',
				'BinCreatedDateTime': 'BinCreatedDateTime'
			}
			this.jsonToCSV('Bin_Report_', this.csvData, this.csvFields);
		},

		getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getOutboundBin()
    },

		resetForm(){
		 this.zone = this.binno = this.FromDate = this.ToDate = this.prnData = ''; this.checkAll = false;
		 this.zoneItem = {
			 value: "",
			 text: ""
		 }
		 this.binDetails = this.BinArr = this.barc = [];
 		 this.getOutboundBin();
		 this.$validator.reset();
	 },

	 check() {
 		 if(typeof InstallTrigger !== 'undefined' == true){ this.checkAll = !this.checkAll; }
		 this.BinArr = [];
		 if (this.checkAll) {
			 this.isLoadingSearch = true; let str = '';
			 for (let i in this.binDetails) {
				 this.BinArr.push(this.binDetails[i]);

				 str = str.concat(`^XA
					^SZ2^JMA
					^MCY^PMN
					^PW812
					~JSN
					~SD25^MD0
					^JZY
					^LH0,0^LRN
					^XZ
					^XA
					^FO7,570
					^GB801,0,3^FS
					^FO8,40
					^GB795,0,3^FS
					^FT225,461
					^CI0
					^A0B,102,105^FD${this.binDetails[i].groupcode}^FS
					^FO482,112
					^BY4^BCB,102,N,N^FD>:${this.binDetails[i].ptlid}^FS
					^FT635,393
					^A0B,56,76^FD${this.binDetails[i].ptlid}^FS
					^PQ1,0,1,Y
					^XZ`);
				 this.prnData = str;
			 }
			 this.isLoadingSearch = false;
		 }
	 },

	 updateCheck(){
		 if(this.binDetails.length == this.BinArr.length){
				this.checkAll = true;
		 }else{
				this.checkAll = false;
		 }
	 },

	 async bulkAction(elem){
	 	 this.barc = [];

		 if(this.BinArr.length>0){
			 let str = ''; this.isLoadingSearch = true;

			 for (let i in this.BinArr) {
				 str = str.concat(`^XA
					^SZ2^JMA
					^MCY^PMN
					^PW812
					~JSN
					~SD25^MD0
					^JZY
					^LH0,0^LRN
					^XZ
					^XA
					^FO7,570
					^GB801,0,3^FS
					^FO8,40
					^GB795,0,3^FS
					^FT225,461
					^CI0
					^A0B,102,105^FD${this.BinArr[i].groupcode}^FS
					^FO482,112
					^BY4^BCB,102,N,N^FD>:${this.BinArr[i].ptlid}^FS
					^FT635,393
					^A0B,56,76^FD${this.BinArr[i].ptlid}^FS
					^PQ1,0,1,Y
					^XZ`);
				 this.prnData = str;

				 let barcUrl = await this.textToBase64Barcode(this.BinArr[i].ptlid);
				 this.barc.push({'base64':barcUrl, 'groupcode':this.BinArr[i].groupcode, 'ptlbinmappingid':this.BinArr[i].ptlbinmappingid});
			 }
			 this.isLoadingSearch = false;

			 if(this.barc.length>0 && elem===0){
				 await this.downloadPDF();
			 }else{
				 await this.printerSticker(this.prnData);
			 }
		 }else{
			 this.$alertify.error('Error: Please Check Checkboxes Before Perform Any Bulk Action.');
		 }
	 },

	 async textToBase64Barcode(text){
 		var canvas = document.createElement("canvas");
		JsBarcode(canvas, text, {format: "CODE39", displayValue: true, fontSize:20, textmargin:"0", fontoptions:"bold"});
 		return canvas.toDataURL("image/png");
 	},

	 async downloadPDF() {
		 const doc = new jsPDF('p', 'pt', 'a4');
		 doc.setFontSize(55).setFontType("bold")
		 doc.setLineWidth(.5)

		 let o=0; let e=0;
		 for (var i = 0; i < this.barc.length; i++) {

		  if(o==2 && e==2){ o=0; e=0; doc.addPage(); }

		 	if(i % 2 == 0) {
				// if the number is even
				doc.rect(32, (45+o*430), 216, 288)
				doc.rect(66, (45+o*430), 144, 288)
				doc.addImage(this.barc[i].base64, 'JPEG', 75, (270+o*430), 128, 50)
				doc.text(80, (170+o*430), this.barc[i].groupcode)
				o++;
		 	}
		 	else {
				// if the number is odd
				doc.rect(334, (45+e*430), 216, 288)
				doc.rect(368, (45+e*430), 144, 288)
				doc.addImage(this.barc[i].base64, 'JPEG', 377, (270+e*430), 128, 50)
				doc.text(380, (170+e*430), this.barc[i].groupcode)
				e++;
		 	}
		 }
		 doc.save("bin-sticker.pdf");
	 },

	 printerSticker(prnData) {

		 this.input = {
			 prnData: prnData,
			 bagNumber: moment().format('DD-MM-YYYY')
		 }
		 this.isLoadingSearch = true;
		 axios({
				 method: "POST",
				 url: "http://localhost:4500/printer/printbagsticker",
				 data: this.input,
			 })
			 .then(result => {
				 console.log(result);
				 if (result.data.ResultCode == 100) {
					 this.updateBagPrintLog();
					 this.$alertify.success(result.data.ReturnMessage);
					 this.$refs.bagNumber.focus()
					 this.$validator.reset();
					 this.errors.clear();
				 } else {
					 this.$alertify.error(result.data.ReturnMessage);
				 }
			 }, error => {
				 var code = error.response == undefined ? code = 0 : error.response.status;
				 if (code == 500) {
					 this.$alertify.error("Printer API error");
					 console.log(error.response.statusText);
				 } else if (error) {
					 this.$alertify.error("Printer not connected")
				 }
			 })
			 this.isLoadingSearch = false;
	 },

	 updateBagPrintLog(){
		 let ptlbinmappingidArr = [...new Set(this.barc.map(a => a.ptlbinmappingid))];

		 this.isLoadingSearch = true;
		 this.input = ({
			 currentHubId: this.hubid,
			 ptlBinMappingId: ptlbinmappingidArr,
			 lastModifiedBy: this.createdby
		 });

		 axios({
				 method: 'POST',
				 url: apiUrl.api_url_hubops + 'scanToBagPrintLog',
				 data: this.input,
				 headers: {
					 'authorization': 'authkey xB84JJ89Hd25'
				 }
			 })
			 .then(async result => {
				 this.isLoadingSearch = false;
				 if (result.data.ResultCode == 100) {
					 await this.getOutboundBin();
					 this.$alertify.success(result.data.ReturnMessage);
				 } else {
					 this.$alertify.error(result.data.ReturnMessage);
				 }
			 }, error => {
				 this.isLoadingSearch = false; console.error(error);
			 })
	 },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BinSticker/OutboundBins/OutboundBins.js